/*eslint-disable*/
import React, { useState } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardImg,
    CardTitle,
    Row,
    Col,
    Modal,
    Input,
    FormGroup,
} from "reactstrap";

// core components
import styled from 'styled-components';
import { LoadingScreen } from "../../MiscFunctions"

const ImageContainer = styled.div`
    padding: 0;
    margin: 0;
    :hover {
        cursor: pointer;
    }
`;

function EventCategory(
    {
        caption,
        description,
        img,
        isDisplayed,
        name,
        size = "4",
        eventCategory,
        setEventCategory,
        del,
        flag,
        setFlag,
        setDeleted
    }) {

    // Modal
    const [smallAlert, setSmallAlert] = useState(false);
    const [classic, setClassic] = useState(false);

    // Confirm Delete After Pressing Modal
    // Will be true 
    const [confirm, setConfirm] = useState("")

    return (
        <>
            <Col md={size} style={{ zIndex: 0 }}>
                {eventCategory ?
                    <Card className="card-profile card-plain" style={{ marginTop: "0" }}>
                        <CardImg top tag="div">
                            <Card
                                className="card-raised page-carousel"
                                style={{ backgroundColor: "inherit", boxShadow: "none" }}
                            >
                                <ImageContainer>
                                    <img
                                        src={img}
                                        alt={name}
                                        style={{ maxHeight: "50vh", width: "auto", minHeight: "40vh" }}
                                        onClick={() => setClassic(true)}
                                    />
                                </ImageContainer>
                            </Card>
                        </CardImg>
                        <CardBody>
                            <Row>
                                <Col md={6} xs={6} lg={6} style={{ textAlign: "right" }}>
                                    <a
                                        data-number="1"
                                        href="#edit"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            document.getElementById("edit").scrollIntoView({
                                                behavior: "smooth",
                                                block: "start",
                                                inline: "nearest",
                                            });
                                        }}
                                    >
                                        <Button
                                            className="btn"
                                            color="info"
                                            type="button"
                                            onClick={() => {
                                                setDeleted([])
                                                setEventCategory(eventCategory)
                                                setFlag(!flag)
                                            }}
                                        >
                                            Edit
                                    </Button>
                                    </a>
                                </Col>
                                {
                                    del &&
                                    <Col md={6} xs={6} lg={6} style={{ textAlign: "left" }}>
                                        <Button
                                            className="btn"
                                            color="danger"
                                            type="button"
                                            onClick={() => {
                                                setSmallAlert(true)
                                                setEventCategory(null)
                                                setFlag(!flag)
                                            }}
                                        >
                                            Delete
                                    </Button>
                                    </Col>
                                }
                            </Row>
                            <CardTitle tag="h4">
                                {caption}
                            </CardTitle>
                            <p className="card-description">
                                {description} <br />
                                Name: {name} <br />
                                Displayed: {isDisplayed.toString()}
                            </p>
                        </CardBody>
                    </Card>
                    :
                    <LoadingScreen />
                }
            </Col>
            {/* Modals */}
            <Modal
                size="sm"
                isOpen={smallAlert}
                toggle={() => setSmallAlert(false)}
            >
                <div className="modal-header no-border-header">
                    <button
                        className="close"
                        type="button"
                        onClick={() => setSmallAlert(false)}
                    >
                        ×
                  </button>
                </div>
                <div className="modal-body text-center">
                    <h5 style={{ fontWeight: "400" }}>
                        Are you sure you want to <span className="text-danger">delete</span>
                        <br />
                        "<i style={{ fontWeight: "500" }}>{eventCategory.name}</i>"?
                        <br />
                        This will also <span className="text-danger">delete all events in this category</span>
                    </h5>
                    <h5 style={{ fontWeight: "400" }}>
                        To confirm, type "{name}" below
                    </h5>
                    <Col md="12">
                        <FormGroup>
                            <Input
                                className="border-input"
                                placeholder={name}
                                type="text"
                                onChange={(event) => setConfirm(`${event.target.value}`)}
                            />
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <div className="left-side">
                        <Button
                            className="btn-link"
                            color="default"
                            type="button"
                            onClick={() => setSmallAlert(false)}
                        >
                            Never mind
                        </Button>
                    </div>
                    <div className="divider" />
                    <div className="right-side">
                        <Button
                            className="btn-link"
                            color="danger"
                            type="button"
                            disabled={!(name === confirm)}
                            onClick={() => {
                                del(eventCategory)
                                setSmallAlert(false)
                            }}
                        >
                            Yes
                        </Button>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={classic}
                toggle={() => setClassic(false)}
                style={{ minWidth: "90vw", maxWidth: "100vw", height: "auto" }}
            >
                <ImageContainer>
                    <img
                        src={img}
                        alt={name}
                        onClick={() => setClassic(false)}
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </ImageContainer>
            </Modal>
        </>
    );
}

export default EventCategory;
